import { useAuth } from 'modules/Auth/hooks/useAuth'
import { useGetIsUserAdminQuery, useListenUserProfileQuery } from 'modules/Users/userApi'
import { canSeeReports } from './reportsUtils'

// Shared by the header button and the route so both always agree.
export function useCanSeeReports() {
  const { userId } = useAuth()
  const { data: profile } = useListenUserProfileQuery({ userId })
  const coachOrgId = profile?.coachOrgId || ''
  const { data: trybeAdminValue } = useGetIsUserAdminQuery({ userId }, { skip: !userId })
  return canSeeReports({ coachOrgId, trybeAdminValue })
}
